import { render, staticRenderFns } from "./TopsDetail.vue?vue&type=template&id=032b11b8&"
import script from "./TopsDetail.vue?vue&type=script&lang=js&"
export * from "./TopsDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports